<!--
 * @Description: 新增编辑业绩参与人
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @Date: 2023-07-13 18:48:55
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 * @LastEditTime: 2023-08-25 16:37:31
-->
<template>
  <div class="cloud-page-com">
    <jw-modal :visible="visible" @ok="handleOk" @cancel="handleCancel" :class="{ 'update-modal': formHeight ? true : false }" title-align="start" width="550px" :mask-closable="false" unmount-on-close :ok-loading="loading">
      <template #title> {{ flag == 1 ? $t('新增业绩参与人') : $t('编辑业绩参与人') }} </template>
      <jw-form :model="form" label-align="right" auto-label-width ref="performanceForm" @submit="handleSubmit" class="select-item" :rules="rules">
        <jw-form-item :label="$t('业绩参与人')" field="userId" show-colon>
          <xl-tree-member-modal ref="xlTreeMember" v-if="flag" :tree="tree" @cb="getVal($event, form.userId, index)" :depart="searchData?.departList" :user="searchData?.userList">
            <jw-input-tag v-model="form.userId" class="user-depart-tags" :max-tag-count="2" :placeholder="$t('请选择协作人')" allow-clear :style="{ width: '300px', marginRight: '10px' }" @remove="removeUserDepart" @clear.stop="clearAll"> </jw-input-tag>
          </xl-tree-member-modal>
          <jw-input v-else v-model="form.userId" disabled :style="{ width: '300px', marginRight: '10px' }"></jw-input>
        </jw-form-item>
        <jw-form-item :label="$t('参与人角色')" field="role" show-colon>
          <jw-select :trigger-props="{ updateAtScroll: true }" :disabled="disabled" :style="{ width: '300px' }" v-model="form.role" :placeholder="$t('请选择参与人角色')" allow-clear allow-search :filter-option="false">
            <jw-option v-for="item in roleOptions" :key="item.value" :value="item.value">{{ item.label }}</jw-option>
          </jw-select>
        </jw-form-item>
        <template v-for="(item, index) in form.weights" :key="index">
          <jw-form-item :label="`${$t('协作阶段')}${index + 1}`" :field="`weights[${index}].stage`" show-colon>
            <div class="stage-list">
              <jw-select :trigger-props="{ updateAtScroll: true }" :disabled="!flag" @change="updateStage(index, $event)" :style="{ width: '300px' }" v-model="item.stage" :placeholder="$t('请选择协作阶段')" allow-clear allow-search :filter-option="false">
                <jw-option v-for="keys in stageOptions" :key="keys.value" :value="keys.value">{{ keys.label }}</jw-option>
              </jw-select>
              <icon-minus-circle size="20" v-if="form.weights.length > 1" class="minus-icon" @click="removeStage(item)" style="margin-left: 10px" />
            </div>
          </jw-form-item>
          <jw-form-item :label="`${$t('绩效比例')}${index + 1}`" :field="`weights[${index}].weight`" show-colon>
            <div class="discount-title"><jw-input-number v-model="item.weight" :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')" :parser="(value) => `${value}`.replace(/\$\s?|(,*)/g, '')" :min="0" :precision="2" allow-clear :placeholder="$t('请输入绩效比例')" :style="{ width: '300px', marginRight: '10px' }" /><span class="symbol">%</span></div>
          </jw-form-item>
        </template>
      </jw-form>
      <p v-if="repeat" style="color: rgb(var(--danger-6))">{{ $t('tips.oppornotRepeat') }}</p>
      <jw-link @click="addStage" v-if="form.weights?.length <= 4 && flag == 1">{{ $t('新增协作阶段') }}</jw-link>
    </jw-modal>
  </div>
</template>
<script>
import { reactive, ref, toRefs, inject, onMounted, watch, computed } from 'vue';
import { opportunityService } from '@/api/';
import { Message } from '@arco-design/web-vue';
import { useI18n } from 'vue-i18n';
// import { roleOptions, stageOptions } from '@/utils/const';
export default {
  setup(props, ctx) {
    const { t } = useI18n();
    console.log(props);
    const visible = ref(false);
    const performanceForm = ref(); //表单
    const formHeight = ref(false);
    const data = reactive({
      form: {
        userId: [],
        role: '', //角色
        weights: [{ id: 1, stage: '', weight: '' }]
      },
      id: inject('detailParams').id, //商机id,
      entity: inject('detailParams').entity,
      loading: false,
      rules: {
        userId: [
          { required: true, message: t('请选择业绩参与人'), trigger: 'input' },
          { maxLength: 1, message: t('只能选择一个业绩参与人') }
        ],
        'weights[0].stage': [{ required: true, message: t('请选择协作阶段'), trigger: 'change' }],
        'weights[0].weight': [{ required: true, message: t('请输入绩效比例'), trigger: 'input' }]
      },
      searchData: {}, //用户列表
      flag: 1,
      roleOptions: [],
      stageOptions: [],
      list: [],
      disabled: false,
      repeat: false
    });
    watch(
      () => data.form.weights,
      (v) => {
        const weights = data.form?.weights;
        weights?.map((item, index) => {
          data.rules[`weights[${index}].stage`] = [{ required: true, message: t('请选择协作阶段'), trigger: 'change' }];
          data.rules[`weights[${index}].weight`] = [{ required: true, message: t('请输入绩效比例'), trigger: 'change' }];
        });
        formHeight.value = false;
        if (v?.length >= 2) {
          formHeight.value = true;
        }
      },
      {
        deep: true
      }
    );
    const open = async (flag, record) => {
      data.flag = flag;
      console.log(record);
      formHeight.value = false;
      visible.value = true;
      data.disabled = false;
      if (data.flag) {
        //新增
        data.list = record; //列表数据
        data.form = {
          userId: [],
          role: '', //角色
          weights: [{ id: 1, stage: '', weight: '' }]
        };
      } else {
        data.form = record;
        if (record.role) {
          data.disabled = true;
        } else {
          data.disabled = false;
        }
      }

      getRoleList();
      getStageList();
    };
    const handleOk = () => {
      performanceForm.value?.handleSubmit();
    };
    const handleCancel = () => {
      formHeight.value = false;
      data.searchData = {};
      visible.value = false;
    };
    //切换协作阶段
    const updateStage = (index, val) => {
      console.log(val);
      console.log(index);
      const userList = data.searchData?.userList;
      userList?.map((user) => {
        const item = data.list?.find((el) => el.user.userId === user.id && el.stage === val);
        console.log(item);
        if (item) {
          Message.error(t('tips.hasPerformance'));
          data.form.weights[index].stage = '';
          return;
        }
      });
      const list = [];
      data.form.weights?.map((item) => {
        if (val) {
          list.push(item.stage);
          const lens = Array.from(new Set(list)).length; //去重;
          if (lens < list.length) {
            //有重复的数据
            data.repeat = true;
          } else {
            data.repeat = false;
          }
        }
      });
    };
    //获取角色列表
    const getRoleList = async () => {
      data.roleOptions = [];
      try {
        const json = await opportunityService.getRolesList();
        if (json.error) {
          Message.error(json.error?.msg || t('操作失败'));
          return false;
        }
        console.log(json);
        data.roleOptions = json?.result;
      } catch (e) {
        console.log(e);
      }
    };
    //获取阶段列表
    const getStageList = async () => {
      data.stageOptions = [];
      try {
        const json = await opportunityService.getStagesList();
        if (json.error) {
          Message.error(json.error?.msg || t('操作失败'));
          return false;
        }
        console.log(json);
        data.stageOptions = json?.result;
      } catch (e) {
        console.log(e);
      }
    };

    //新增/编辑业绩参与人
    const addPerformance = async () => {
      data.loading = true;
      console.log(data.searchData);
      if (data.flag) {
        data.form.weights?.map((item) => {
          item.id = '';
        });
      }
      const params = {
        id: data.id,
        entity: data.entity,
        ...data.form,
        userId: data.flag == 1 ? data.searchData?.userList[0].id : data.form?.user?.userId
      };
      console.log(params);
      try {
        const json = await opportunityService.updateStageWeights(params);
        data.loading = false;
        if (!json.error) {
          console.log(json);
          Message.success(t('操作成功'));
          handleCancel();
          ctx.emit('cb');
        } else {
          Message.error(json.error?.msg || t('操作失败'));
        }
      } catch (e) {
        console.log(e);
        data.loading = false;
        Message.error(e.message || e.statusText || t('操作失败'));
      }
    };
    //删除业绩人
    const removeStage = (record) => {
      const weights = data.form.weights;
      weights.map((item, index) => {
        if (item.id == record.id) {
          weights.splice(index, 1);
        }
      });
      data.form.weights = weights;
      updateRole();
    };
    //新增参与阶段
    const addStage = () => {
      const lens = data.form.weights.length;
      data.form.weights.push({ id: lens + 1, stage: '', weight: '' });
    };
    //表单提交
    const handleSubmit = ({ values, errors }) => {
      console.log('values', values);
      console.log('errors', errors);
      if (errors) {
        const errorArray = {};
        Object.values(errors).forEach((key, index) => {
          errorArray[key.field] = { status: 'error', message: '' };
          Object.values(errorArray).forEach((i, ind) => {
            if (index === ind) {
              i.message = key.message;
            }
          });
        });
        performanceForm.value.setFields(errorArray);
        return;
      }
      const list = [];
      data.form.weights?.map((item) => {
        if (item.stage) {
          list.push(item.stage);
          const lens = Array.from(new Set(list)).length; //去重;
          if (lens < list.length) {
            //有重复的数据
            data.repeat = true;
          } else {
            data.repeat = false;
          }
        }
      });
      // console.log(addPerformance);
      if (!data.repeat) {
        addPerformance();
      }
    };
    onMounted(() => {});
    // 选择部门和人员
    const tree = reactive({
      checkDepartment: false,
      isAll: true
    });
    const getVal = (v) => {
      data.searchData = v;
      console.log(v);
      const userNames = computed(() => v?.userList?.map((u) => u.userName));
      console.log(userNames.value);
      if (userNames?.value) {
        performanceForm.value?.clearValidate(['userId']);
        data.form.userId = userNames.value;
      }
      updateRole();
    };
    const updateRole = () => {
      const userList = data.searchData?.userList;
      console.log(userList);
      if (userList.length) {
        userList?.map((user) => {
          const item = data.list?.find((el) => el.user.userId === user.id);
          console.log(item);
          data.form.role = item?.role ? item?.role : '';
          data.disabled = item?.role ? true : false;
        });
      } else {
        data.form.role = '';
        data.disabled = false;
      }
    };
    // 删除用户或部门
    const removeUserDepart = (removed) => {
      console.log(97, removed);
      const userItem = data.searchData?.userList.findIndex((item) => item.userName === removed);
      if (userItem !== -1) {
        data.searchData?.userList?.splice(userItem, 1);
      }
      updateRole();
    };
    // 清除所有
    const clearAll = (ev) => {
      console.log(101, ev);
      if (data.searchData) {
        data.searchData.userList = [];
      }
      updateRole();
    };
    return {
      visible,
      performanceForm,
      formHeight,
      open,
      handleOk,
      handleCancel,
      handleSubmit,
      addStage,
      removeStage,
      tree,
      getVal,
      removeUserDepart,
      clearAll,
      updateStage,
      ...toRefs(data)
    };
  }
};
</script>
<style scoped lang="less">
@import './index.less';
</style>
<style>
.update-modal .arco-modal-body {
  height: 450px;
  overflow: hidden;
  overflow-y: scroll;
}
</style>
